export const MonthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]

const BCStatus = {
  default_None: {id: "", display: "None", order: 0},
  default_Booked: {id: "booked", display: "Booked", order: 1},
  default_Call_Back: {id: "callback", display: "Call Back", order: 2},
  default_Sold: {id: "sold", display: "Sold", order: 3},
  default_Not_Sold: {id: "notsold", display: "Not Sold", order: 4},
  default_PNI: {id: "pni", display: "PNI", order: 5},
  default_No_Show: {id: "noshow", display: "No Show", order: 6},
  default_Former_Client: {id: "formerclient", display: "Former Client", order: 7},
  default_Bad_Number: {id: "badnumber", display: "Bad Number", order: 8},
  default_Odd: {id: "odd", display: "Odd", order: 9},
}

export function getBCStatus(bcStatus) {
  for (let key of Object.keys(BCStatus)) {
    if (BCStatus[key].id === bcStatus) {
      return BCStatus[key];
    }
  }
  return {id: bcStatus, display: "Unknown", order: 0}
}

export function getBCStatusList() {
  let arr = [];
  for (let key of Object.keys(BCStatus)) {
    arr.push(BCStatus[key]);
  }
  return arr;
}




// WEBPACK FOOTER //
// ./src/constants/BCConstants.js